import React, { useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';

import useApi from 'common/useApi';

import InputPassword from 'components/InputPassword';
import useFormApiErrors from 'common/useFormApiErrors';
import classNames from 'classnames';
import Loading from 'components/Loading';

const ChangePassword = () => {
  const formMethods = useForm({ mode: 'onChange' });
  const { handleSubmit, formState: { isSubmitting, isValid, isDirty }, setError, setValue } = formMethods;
  const { error, isLoading, isFetching, isError, isSuccess, mutate } = useApi('post', '/api/me/update-password');

  useFormApiErrors(isError, error, setError, isSuccess, 'Password updated successfully');

  const onSubmit = ({ current_password, new_password, new_password_confirm }: Record<string, string>) => {
    mutate({
      current_password,
      new_password,
      new_password_confirm,
    });
  };

  useEffect(() => {
    if(isSuccess) {
      setValue('current_password', null);
      setValue('new_password', null);
      setValue('new_password_confirm', null);
    }
  }, [isSuccess]);

  const formDisabled = isSubmitting || isLoading || isFetching || (!isValid && isDirty);

  return (
    <>
      <h3>Change Password</h3>
      <div
        className={classNames({
          box: true,
          isLoading,
        })}
      >
        {isLoading && <Loading />}
        <FormProvider {...formMethods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <InputPassword
              name='current_password'
              className='half'
              title='Current Password'
              placeholder='Current Password'
              disabled={isLoading}
            />
            <InputPassword
              name='new_password'
              className='half'
              title='New Password'
              placeholder='New Password'
              disabled={isLoading}
            />
            <InputPassword
              name='new_password_confirm'
              placeholder='Confirm New Password'
              title='Confirm New Password'
              className='half'
              match='new_password'
              disabled={isLoading}
            />
            <button type='submit' className='primary big' disabled={formDisabled}>Change Password</button>
          </form>
        </FormProvider>
      </div>
    </>
  );

};

export default ChangePassword;